import React, { FC, useMemo } from 'react'
import { IonFooter, IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { orderMobx } from 'restaurant'
import { toPrice, classNames, ddayjs } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import ProductItems from '../components/ProductItems'
import Discount from '../components/Discount'
import { observer } from 'mobx-react'
import { TEOrdersRefundStatus } from '@common/enum/order.enum'
import { find } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps extends RouteComponentProps { }

const Refund: FC<IProps> = ({ match }) => {
  const { ordersId } = match.params as any
  const { viewOrder } = orderMobx
  const history = useHistoryNew()
  const refundInfo = viewOrder.ordersRefundList?.[viewOrder.ordersRefundList?.length - 1]
  const refundStatus = refundInfo?.status as TEOrdersRefundStatus
  const refundList = useMemo(() => {
    let list = [{
      status: TEOrdersRefundStatus.Pending,
      time: ddayjs(refundInfo?.addTime).format('MM-DD HH:mm'),
      name: i18n.t(`refund.status.${TEOrdersRefundStatus.Pending}`),
      desc: i18n.t(`refund.statusDesc.${TEOrdersRefundStatus.Pending}`, { date: ddayjs(refundInfo?.addTime).add(24, 'hour').format('YYYY-MM-DD HH:mm') })
    }]
    if (refundStatus !== TEOrdersRefundStatus.Pending) {
      let rejectInfo: { attrValue: string; attrName: string } = find((viewOrder.extList || []), (item) => item.attrName === 'rejectMessage')
      list.unshift({
        status: refundStatus,
        time: ddayjs(refundInfo?.modifyTime).format('MM-DD HH:mm'),
        name: `${i18n.t(`refund.status.${refundStatus}`)} ${refundStatus === TEOrdersRefundStatus.Success ? toPrice(viewOrder.paidFee) : ''}`,
        desc: i18n.t(`refund.statusDesc.${refundStatus}`, { reason: rejectInfo?.attrValue })
      })
    }
    return list
  }, [refundInfo])

  const handleCancel = () => {
    history.replace('/orders')
  }

  const initOrder = () => {
    orderMobx.init(ordersId).catch(() => { })
  }
  useIonViewWillEnter(() => {
    initOrder()
  })
  return (
    <IonPage className='order-refund-detail-page'>
      <IonContent>
        <div className='order-refund-content'>
          <div className='refund-new-status-wrapper'>
            <div className='refund-new-status'>{refundList?.[0].name}</div>
            {[TEOrdersRefundStatus.Timeout, TEOrdersRefundStatus.Reject].includes(refundStatus as TEOrdersRefundStatus) && <div className='refund-new-status-desc'>{refundList?.[0].desc}</div>}
          </div>
          <div className='refund-item-wrapper'>
            <div className='title-wrapper'>{i18n.t('refund.refundStep')}</div>
            <div className='refund-step-wrapper'>
              {
                refundList.map((item) => {
                  return (
                    <div className={classNames('refund-step-item', item.status)} key={item.status}>
                      <div className='step-tail'></div>
                      <div className='step-icon'></div>
                      <div className='step-content'>
                        <div className='step-title'>
                          <span className='title'>{item.name}</span>
                          <span className='date'>{item.time}</span>
                        </div>
                        <span className='step-desc'>{item.desc}</span>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='refund-item-wrapper'>
            <div className='title-wrapper'>{i18n.t('refund.product')}</div>
            <ProductItems />
            <Discount />
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='footer-btn'>
          <div className='cancel' onClick={handleCancel}>{i18n.t('refund.refundBackOrders')}</div>
        </div>
      </IonFooter>
    </IonPage>
  )
}
export default observer(Refund)
